import client from "../services/api"


export const getPaymentClient = (page?:number, perPage?: number) => {
    return client.get(`/clients/payments`, {params: {page, per_page: perPage}})
}

export const getTransactionClient = async (page?: number, per_page?: number) => {
    const data = await client.get(`/clients/wallet/transactions`, {params: {page, per_page}})

    if (data.data?.data) {
        data.data.data.map((d:any) => {
            d.extra_info = JSON.parse(d.extra_info)
        })
    }

    return data
}

export const getAllClientProducts = (page?:number, per_page?: number) => {
    return client.get('/clients/products', {params: {page, per_page:per_page}})
}

export const getLogisticsClient = () => {
    return client.get(`/clients/logistics`)
}

export const getPrizesClient = () => {
    return client.get(`/clients/prizes`, {params: {per_page: 10000}})
}

export const toggleTwoStepVerification = () => {
    return client.get('/users/two-steps')
}

export const financialInfo = () => {
    return client.get(`/users/financial/info`)
}